module.exports = __webpack_public_path__ + "static/media/support.feee01ac.svg";